<template>
  <section class="numbers">
    <div class="container-grid">
      <section class="coluna">
        <div class="numerosRS">+2,5 {{ $t('homePage.milhao') }}</div>
        <div class="descrRS">{{ $t('homePage.seguidores') }}</div>
      </section>
      <section class="coluna">
        <div class="numerosRS">+250 {{ $t('homePage.milhao') }}</div>
        <div class="descrRS">{{ $t('homePage.visu') }}</div>
      </section>
      <section class="coluna">
        <div class="numerosRS">+30 {{ $t('homePage.milhao') }}</div>
        <div class="descrRS">{{ $t('homePage.curtidas') }}</div>
      </section>
    </div>
  </section>
</template>

<style scoped>
section.numbers {
  min-height: 0;
  background: var(--color-bg-dark);
  color: var(--color-light);
  display: flex;
  align-items: center;
}

.container-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  max-width: 1100px;
  width: 90vw;
  margin: 0 auto;
  padding: 40px 24px;
}

section.data {
  border: 1px solid #333;
}

.numerosRS {
  font-family: "Bebas Neue", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 50px;
}

.descrRS {
  font-family: "Archivo", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-variation-settings: "wdth" 100;
}

@media (aspect-ratio <= 3/4) {
  .container-grid {
    max-width: none;
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
    gap: 8px;
  }

  .numerosRS {
    font-size: 30px;
    line-height: 1.05;
  }

  .descrRS {
    font-size: 14px;
    line-height: 1.2;
  }
}
</style>
